module.exports = __webpack_public_path__ + "img/BLCA_Fibroblasts.6024cc33.png";